import React from 'react';
import classNames from 'classnames';

import WrapperWidget from '../Wrapper';
import InputTextArea from '../../../FormFields/TextArea';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import withConditions from '../withConditions';
import { fontSizeOptions } from '../../../../Models/Section';

import './style.scss';

export class FormDescriptionWidget extends React.PureComponent {

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const { field } = this.props;

    return (
      <div className='Widget_Form_Config'>
        <InputTextArea label='Text' required value={ internalField.label }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputSelect label='Font size' value={ internalField.fontSize }
                     onChange={ (v) => changeFieldValue('fontSize', v) } options={ fontSizeOptions() }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('bold', v) } label='Bold'
                    checked={ internalField.bold }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('italic', v) } label='Cursive'
                    checked={ internalField.italic }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
        </div>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, api} = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Form Description',
      headerHidden: true
    };
    return (
      <WrapperWidget {...props}>
        <div className='FormDescriptionWidget'>
          <div  className={ classNames('Widget_Label', {
                  Bold: Boolean(field.bold),
                  Italic: Boolean(field.italic),
                }) }
          >
            <p style={ { fontSize: field.fontSize ? field.fontSize.label : null } }
               className={ classNames('FormDesription_Label', {
                 Bold: Boolean(field.bold),
                 Italic: Boolean(field.italic),
               }) }
            >
              { api ? api.getFieldsVerbiage(field, 'label') : field.label }
            </p>
          </div>
        </div>
      </WrapperWidget>
    );
  }
}

export const FormDescriptionWidgetEditable = withConditions(FormDescriptionWidget);